
























import { Component, Inject, Mixins } from "vue-property-decorator";
import BrandsStore from "@/mixins/brandsStore";
import HasValidation from "@/mixins/HasValidation";
import {
  IBrandFieldsProviderData,
  IBrandFieldsProviderMethods
} from "@/models/providers/brandFields";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  }
})
export default class ManageBrandFieldsForm extends Mixins(
  BrandsStore,
  HasValidation
) {
  // Inject
  @Inject({ from: "brandFieldsProvider" })
  public brandFieldsProvider!: () => IBrandFieldsProviderData;

  @Inject({ from: "brandFieldsProviderMethods" })
  public $brandFieldsMethods!: IBrandFieldsProviderMethods;

  // Data
  public isLoading = false;

  public form = {
    provision_field_values: {}
  } as any;

  public initialForm = {
    provision_field_values: {}
  } as any;

  // Life-cycle methods

  public created() {
    this.initializeForm();
    this.$watch("form", () => this.$emit("input", this.form), {
      deep: true,
      immediate: true
    });
    this.$watch(
      "initialForm",
      () => this.$emit("initialForm", this.initialForm),
      {
        deep: true,
        immediate: true
      }
    );
  }

  // Computed

  public get $brandFieldsData() {
    return this.brandFieldsProvider();
  }

  public get isReloading() {
    return this.$brandFieldsData.isReloading;
  }

  public get brandFields() {
    return this.$brandFieldsData.brandFields;
  }

  public get brandFieldsValues() {
    return this.$brandFieldsData.brandFieldsValues;
  }

  public get guardFunctionalities() {
    return this.$brandFieldsData.guardFunctionalities;
  }

  public get blueprintId() {
    return this.$brandFieldsData.blueprintId;
  }

  // Methods

  public initializeForm() {
    this.$_.forEach(this.brandFields, field => {
      this.$set(
        this.form.provision_field_values,
        field.name,
        this.$_.get(
          this.$_.find(this.brandFieldsValues, fieldValue => {
            return (
              fieldValue.blueprint_id === this.blueprintId &&
              fieldValue.blueprint_field_id === field.id
            );
          }),
          "value",
          ""
        )
      );
    });
    this.initialForm = this.$_.cloneDeep(this.form);
  }

  public revertToInitialState() {
    this.initializeForm();
    // this.form = { ...this.initialForm };
  }

  public async validateBeforeSubmit() {
    if (!this.$brandFieldsData.canSave) {
      return;
    }
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      this.$brandFieldsMethods.setIsProcessing(true);

      await this.$brandFieldsMethods.updateBrandFields(this.form);
      await this.$brandFieldsMethods.getBrandProvisiongFieldsValues(true);
      this.initializeForm();
      this.$buefy.toast.open({
        message: this.$t(`_.fields_updated`) as string
      });
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.$brandFieldsMethods.setIsProcessing(false);
    }
  }
}
